import React, { useEffect } from "react"

import { useNavigate } from "react-router-dom"

import { AuthHelper } from "../../helpers/auth.helper"
import { useAppDispatch } from "../../store/appDispatch.hook.ts"

export const LogoutComponent: React.FunctionComponent = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            AuthHelper.logout(dispatch, undefined, navigate)
        })

        return () => {
            clearTimeout(timeoutId)
        }
    }, [])

    return null
}
